<div class="segment-control" [ngClass]="size" [ngStyle]="{ width: width }" role="tablist">
  <span
    class="segment-control__indicator"
    [class.segment-control__indicator--visible]="indicator().visible"
    [ngStyle]="{ transform: 'translateX(' + indicator().left + 'px)', width: indicator().width + 'px' }"
    aria-hidden="true"></span>

  @for (segment of segments; track segment.value) {
    <button type="button" class="segment" role="tab" [ngClass]="{ selected: isSelected(segment), disabled: segment.disabled }" [ngStyle]="{ padding: segmentPadding }" [attr.aria-selected]="isSelected(segment)" [disabled]="segment.disabled" (click)="selectSegment(segment)">
      <span [agText]="'body-3-medium'">{{ segment.label }}</span>
    </button>
  }
</div>
